export const categories = [
  { slug: 'all', name: '全部文章' },
  { slug: 'tutorial', name: '创作教程' },
  { slug: 'teamwork', name: '团队协作' },
  { slug: 'tools', name: '工具推荐' },
  { slug: 'case-study', name: '案例分享' },
  { slug: 'industry', name: '行业动态' },
];

export const articles = [
  {
    slug: 'team-video-editing-workflow-guide',
    title: '团队视频剪辑协作全流程指南：从草稿到成片',
    excerpt: '多人同时编辑一个视频项目不再是梦想。本文详细拆解团队视频协作的完整工作流，帮你告别版本混乱、沟通低效的痛点。',
    category: 'teamwork',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20video%20editing%20workspace%20with%20multiple%20monitors%20showing%20timeline%20editing%20software%2C%20warm%20creative%20studio%20atmosphere%2C%20team%20collaboration%20setup%2C%20minimalist%20desk%20with%20professional%20equipment%2C%20soft%20natural%20lighting%2C%20clean%20aesthetic&width=800&height=450&seq=article-cover-01&orientation=landscape',
    author: '张明远',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20in%20creative%20studio%2C%20warm%20lighting%2C%20friendly%20expression%2C%20clean%20background&width=100&height=100&seq=author-01&orientation=squarish',
    date: '2026-08-10',
    readTime: '8分钟',
    tags: ['视频剪辑', '团队协作', '工作流'],
    content: `在当今内容为王的时代，视频创作已经从单打独斗走向了团队协作。一个优质视频的诞生，往往需要策划、拍摄、剪辑、调色、音效、字幕等多个环节的紧密配合。

但团队协作也带来了新的挑战：版本管理混乱、沟通成本高、文件传输慢、反馈周期长……这些问题严重拖慢了创作效率。

一起草视频正是为了解决这些痛点而生。作为一个专为创作者打造的协作平台，它重新定义了团队视频创作的工作方式。以下是完整的团队视频协作流程指南。

## 第一阶段：项目规划与分工

在打开任何剪辑软件之前，团队需要先在一起草视频上完成以下准备工作：

1. 创建项目空间，邀请团队成员加入
2. 在项目看板上拆解任务：策划、脚本、拍摄、粗剪、精剪、调色、音效、字幕
3. 设置每个任务的负责人和截止日期
4. 上传参考素材和创意简报

## 第二阶段：素材管理与共享

素材管理是团队协作中最容易被忽视但至关重要的一环。一起草视频提供了集中化的素材库，支持：

- 批量上传和多格式兼容
- 智能标签和分类管理
- 版本控制和历史回溯
- 实时同步，团队成员随时获取最新素材

## 第三阶段：协同编辑与反馈

这是一起草视频最核心的能力。多人可以同时对同一个项目进行编辑，所有操作实时同步。审阅者可以在时间轴的任意位置添加标注和评论，剪辑师直接在标注位置进行调整。

告别"导出-发送-等待反馈-修改-再导出"的低效循环，所有协作都在同一个平台上完成。

## 第四阶段：成品输出与发布

完成编辑后，一起草视频支持一键导出多种格式，并打通了各大视频平台的发布接口，实现从创作到发布的无缝衔接。`,
  },
  {
    slug: 'how-to-manage-video-drafts-efficiently',
    title: '视频草稿管理终极指南：告别混乱版本',
    excerpt: '还在用 V1、V2、最终版、最终版2 来命名草稿吗？学会这套草稿管理方法论，让你的创作过程井井有条。',
    category: 'tutorial',
    coverImage: 'https://readdy.ai/api/search-image?query=Organized%20digital%20workspace%20showing%20video%20project%20version%20management%20interface%2C%20clean%20minimalist%20UI%20design%2C%20timeline%20comparison%20view%2C%20warm%20studio%20lighting%2C%20modern%20creative%20environment&width=800&height=450&seq=article-cover-02&orientation=landscape',
    author: '李思涵',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%20in%20modern%20office%2C%20warm%20lighting%2C%20confident%20expression%2C%20clean%20background&width=100&height=100&seq=author-02&orientation=squarish',
    date: '2026-08-08',
    readTime: '6分钟',
    tags: ['草稿管理', '版本控制', '效率提升'],
    content: `如果你是一个视频创作者，"最终版_v3_真的最终.mp4"这个文件名一定不陌生。草稿版本混乱几乎是每个创作者的必经之痛。

本指南将为你系统性地解决视频草稿管理的问题。

## 为什么草稿管理如此重要？

一个典型的商业视频项目，从初稿到交付，通常需要经历5-10个版本迭代。如果没有良好的管理习惯，很容易出现以下问题：

- 发给客户的是旧版本
- 找不到三天前修改的那个特效
- 不小心覆盖了同事的修改
- 硬盘里塞满了重复的大文件

## 一起草视频的草稿管理方案

一起草视频提供了业界领先的草稿管理系统，核心功能包括：

### 自动版本记录

每次保存都会自动生成一个新版本，你随时可以回溯到任意历史版本。每个版本都会记录修改人、修改时间和修改内容摘要。

### 版本对比

并排对比任意两个版本的差异，精确到帧级别的变化可视化，让你一目了然地看到每次修改的具体内容。

### 分支管理

类似于代码的 Git 分支，你可以创建不同的编辑分支。主分支保持稳定版本，实验性的修改在分支上进行，确认后再合并回主分支。

### 智能命名

告别手动命名。系统会根据项目名称、版本号和修改内容自动生成规范的版本标识，并支持快速搜索和筛选。

## 最佳实践建议

1. 建立团队统一的版本管理规范
2. 重要节点手动打标签（如"客户确认版"、"交付版"）
3. 定期清理不再需要的中间版本
4. 利用评论功能记录每次修改的决策理由`,
  },
  {
    slug: 'top-5-video-collaboration-tools-2026',
    title: '2026年视频协作工具Top 5横评：哪款最适合你的团队？',
    excerpt: '市面上视频协作工具眼花缭乱，我们深度体验了5款主流工具，从功能、价格、易用性等多个维度为你全面解析。',
    category: 'tools',
    coverImage: 'https://readdy.ai/api/search-image?query=Five%20different%20video%20editing%20software%20interfaces%20displayed%20on%20screens%2C%20comparison%20layout%2C%20modern%20tech%20review%20setup%2C%20warm%20lighting%2C%20clean%20minimalist%20aesthetic&width=800&height=450&seq=article-cover-03&orientation=landscape',
    author: '王浩然',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20tech%20reviewer%20portrait%2C%20modern%20studio%2C%20warm%20lighting%2C%20friendly%20expression&width=100&height=100&seq=author-03&orientation=squarish',
    date: '2026-08-05',
    readTime: '10分钟',
    tags: ['工具测评', '协作平台', '横评对比'],
    content: `随着远程办公和分布式团队的普及，视频协作工具市场在2026年迎来了爆发式增长。面对琳琅满目的选择，哪款工具最适合你的团队？

我们花费了两周时间，深度体验了市面上最热门的5款视频协作工具，从以下维度进行全面评测：

- 实时协作能力
- 版本管理与草稿回溯
- 素材库管理
- 审阅与反馈流程
- 导出与发布集成
- 价格与性价比

## 1. 一起草视频 - 综合最佳

作为本次横评的标杆产品，一起草视频在多个维度上表现出色。其实时协作引擎延迟低至毫秒级，版本管理借鉴了Git的设计理念，非常适合专业创作团队。

## 2-5. 其他工具对比

每款工具都有其独特的优势和适用场景，详细的功能对比和价格分析请参见正文。最终我们推荐：小型团队从一起草视频的基础版开始，中型以上团队选择专业版以获得完整的协作体验。`,
  },
  {
    slug: 'short-video-teamwork-strategy',
    title: '短视频矩阵运营：如何用团队协作实现日产百条',
    excerpt: '一个人日更3条已是极限，但一个团队协同作战可以实现日产百条。揭秘头部MCN团队的协作秘诀。',
    category: 'case-study',
    coverImage: 'https://readdy.ai/api/search-image?query=Busy%20creative%20team%20working%20on%20short%20video%20content%20in%20modern%20studio%2C%20multiple%20screens%20showing%20social%20media%20dashboards%2C%20energetic%20atmosphere%2C%20warm%20lighting&width=800&height=450&seq=article-cover-04&orientation=landscape',
    author: '陈雨萱',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20social%20media%20strategist%20portrait%2C%20modern%20office%2C%20warm%20confident%20expression&width=100&height=100&seq=author-04&orientation=squarish',
    date: '2026-08-02',
    readTime: '7分钟',
    tags: ['短视频', 'MCN', '矩阵运营'],
    content: `短视频行业的竞争已经进入白热化阶段。"内容为王"早已不是秘密，真正拉开差距的是内容生产效率。

我们走访了多家头部MCN机构，发现他们有一个共同的秘密武器：高效的团队协作体系，让内容生产效率提升了10倍以上。

## 传统模式的瓶颈

一个创作者独立完成一条短视频，从选题、脚本、拍摄、剪辑到发布，平均需要4-6小时。按每天工作8小时计算，一个人最多日产2条。

但头部账号每天更新5-10条甚至更多，他们是怎么做到的？答案就是：流水线化的团队协作。

## 一起草视频如何实现日产百条

### 分工专业化

- 选题组：基于热点和数据分析，每小时产出20个选题
- 脚本组：根据选题快速撰写脚本模板
- 拍摄组：按脚本批量拍摄素材
- 剪辑组：在一起草视频上多人并行剪辑
- 审核组：实时审核、标注修改意见

### 模板化生产

一起草视频支持创建项目模板，将常用的片头、转场、字幕样式、片尾保存为模板，剪辑师直接套用，大幅减少重复工作。

### 并行流水线

传统模式是串行的，而一起草视频支持真正的并行协作。当一个选题的素材上传完成后，多个剪辑师可以同时开始工作，互不影响。`,
  },
  {
    slug: 'ai-video-editing-trends-2026',
    title: 'AI视频编辑新时代：2026年最值得关注的5大技术趋势',
    excerpt: 'AI正在重塑视频创作的方式。从智能剪辑到自动字幕，这5大趋势将深刻改变创作者的工作方式。',
    category: 'industry',
    coverImage: 'https://readdy.ai/api/search-image?query=Futuristic%20AI%20video%20editing%20interface%20with%20holographic%20displays%2C%20neural%20network%20visualization%2C%20warm%20modern%20tech%20aesthetic%2C%20clean%20studio%20environment&width=800&height=450&seq=article-cover-05&orientation=landscape',
    author: '赵文博',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20tech%20analyst%20portrait%2C%20modern%20minimalist%20background%2C%20warm%20expression&width=100&height=100&seq=author-05&orientation=squarish',
    date: '2026-07-30',
    readTime: '9分钟',
    tags: ['AI技术', '行业趋势', '智能剪辑'],
    content: `人工智能在视频创作领域的应用正在以前所未有的速度发展。2026年，我们看到了AI从辅助工具到核心生产力的转变。

一起草视频也在积极拥抱AI技术，将智能化的能力融入到团队协作的每个环节中。以下是今年最值得关注的5大AI视频编辑趋势。`,
  },
  {
    slug: 'remote-video-team-best-practices',
    title: '远程视频团队协作最佳实践：跨越时空的创作力',
    excerpt: '分布式团队如何保持高效的视频创作节奏？从沟通机制到工具选型，为你拆解远程协作的方方面面。',
    category: 'teamwork',
    coverImage: 'https://readdy.ai/api/search-image?query=Remote%20creative%20team%20video%20conference%20on%20large%20screen%2C%20distributed%20workspace%2C%20modern%20home%20office%20setup%2C%20warm%20lighting%2C%20collaborative%20atmosphere&width=800&height=450&seq=article-cover-06&orientation=landscape',
    author: '张明远',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20in%20creative%20studio%2C%20warm%20lighting%2C%20friendly%20expression%2C%20clean%20background&width=100&height=100&seq=author-01&orientation=squarish',
    date: '2026-07-28',
    readTime: '7分钟',
    tags: ['远程办公', '分布式团队', '协作技巧'],
    content: `后疫情时代，远程办公已成为创意行业的常态。但对于视频创作这种对协作要求极高的领域来说，远程工作带来了一系列独特的挑战。本文将分享经过验证的远程视频团队协作最佳实践。`,
  },
  {
    slug: 'video-content-marketing-guide',
    title: '视频内容营销全攻略：从策划到转化的完整闭环',
    excerpt: '视频不再只是品牌宣传的加分项，而是营销的核心引擎。学会用数据驱动的方式做视频内容，让每一秒都产生价值。',
    category: 'tutorial',
    coverImage: 'https://readdy.ai/api/search-image?query=Marketing%20dashboard%20with%20video%20analytics%20charts%20and%20graphs%2C%20modern%20business%20intelligence%20setup%2C%20warm%20office%20lighting%2C%20clean%20professional%20aesthetic&width=800&height=450&seq=article-cover-07&orientation=landscape',
    author: '李思涵',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%20in%20modern%20office%2C%20warm%20lighting%2C%20confident%20expression%2C%20clean%20background&width=100&height=100&seq=author-02&orientation=squarish',
    date: '2026-07-25',
    readTime: '11分钟',
    tags: ['内容营销', '数据分析', '转化优化'],
    content: `在2026年的数字营销格局中，视频内容的地位已经无可撼动。数据显示，包含视频的营销活动转化率比纯图文高出80%以上。但简单地"做视频"已经不够，你需要一套完整的视频内容营销体系。`,
  },
  {
    slug: 'yqicao-video-platform-deep-dive',
    title: '一起草视频深度体验：我们用30天测试了这个协作平台',
    excerpt: '30天、5人团队、15个视频项目——我们以真实创作流程全面测试一起草视频的每一个功能。这份深度报告告诉你它到底值不值得。',
    category: 'case-study',
    coverImage: 'https://readdy.ai/api/search-image?query=Creative%20team%20testing%20video%20collaboration%20platform%20on%20multiple%20devices%2C%20modern%20studio%20with%20timeline%20screens%2C%20warm%20atmosphere%2C%20focused%20expressions&width=800&height=450&seq=article-cover-08&orientation=landscape',
    author: '王浩然',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20tech%20reviewer%20portrait%2C%20modern%20studio%2C%20warm%20lighting%2C%20friendly%20expression&width=100&height=100&seq=author-03&orientation=squarish',
    date: '2026-07-20',
    readTime: '12分钟',
    tags: ['产品评测', '深度体验', '真实案例'],
    content: `作为一支日均产出3-5条视频的创作团队，我们一直在寻找一款真正好用的视频协作工具。当一起草视频发布后，我们决定用30天时间，以真实的创作流程来全面测试它。以下是我们的深度体验报告。`,
  },
];

export const faqList = [
  {
    question: '一起草视频支持哪些视频格式？',
    answer: '一起草视频支持目前市面上几乎所有主流视频格式，包括MP4、MOV、AVI、MKV、WebM、ProRes等。上传时系统会自动进行格式识别和兼容性检测，确保素材可以被正常使用。对于超大文件，我们还提供了智能压缩上传功能，在保证画质的前提下优化传输速度。',
  },
  {
    question: '多人同时编辑同一个视频项目会冲突吗？',
    answer: '不会。一起草视频采用先进的实时协作引擎，支持类似在线文档的多人同时编辑体验。不同团队成员可以同时处理不同的时间轴段落，系统会智能处理操作合并。当一个成员操作了某个片段时，其他成员会看到实时锁定提示，避免覆盖操作。',
  },
  {
    question: '免费版有哪些功能限制？',
    answer: '免费版提供完整的核心协作功能，包括最多3人的团队协作、10GB云端存储空间、基础版本管理（保留最近20个版本）。对于个人创作者和小型团队来说，免费版已经能够满足日常创作需求。专业版解锁更多高级功能，如无限版本记录、智能审阅、API接入等。',
  },
  {
    question: '我的数据在一起草视频上安全吗？',
    answer: '安全是我们的首要考虑。一起草视频采用企业级加密标准，所有数据传输和存储均经过AES-256加密。我们通过了SOC 2 Type II认证，并在全球多个数据中心部署了冗余备份。此外，我们提供细粒度的权限控制，你可以精确设置每个团队成员对每个项目的访问级别。',
  },
  {
    question: '可以和其他剪辑软件配合使用吗？',
    answer: '当然可以。一起草视频设计了开放的生态系统，支持与Adobe Premiere Pro、Final Cut Pro、DaVinci Resolve等主流剪辑软件的项目文件互导。你可以在本地软件中开始创作，然后上传到平台进行团队协作，或者反过来，灵活适配各种工作流。',
  },
  {
    question: '如何邀请团队成员加入项目？',
    answer: '邀请团队成员非常简单。在项目页面点击"邀请成员"按钮，你可以通过邮箱邀请、分享邀请链接或从已有的团队通讯录中快速添加。每个成员可以设置不同的角色权限：管理员、编辑者、审阅者和只读观察者，灵活控制团队协作的安全性。',
  },
  {
    question: '支持多平台使用吗？',
    answer: '一起草视频提供Web端（浏览器直接使用，无需安装）、Windows客户端、macOS客户端以及iOS和Android移动端应用。所有平台实时同步，你可以在办公室用台式机编辑，在路上用手机审阅反馈，在家里用笔记本继续工作。',
  },
  {
    question: '能否直接发布到各大视频平台？',
    answer: '可以。一起草视频内置了一键发布功能，目前已打通B站、抖音、快手、YouTube、视频号等主流视频平台的发布接口。你可以在完成编辑后直接选择目标平台、设置标题和标签，一键分发，大幅提升发布效率。',
  },
];

export const testimonials = [
  {
    name: '刘星宇',
    role: '知名Vlogger / 200万粉丝',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20vlogger%20portrait%2C%20warm%20studio%20lighting%2C%20friendly%20expression%2C%20clean%20background&width=100&height=100&seq=testimonial-01&orientation=squarish',
    content: '之前和剪辑师来回传文件效率太低了，用了一起草视频后，我们可以在同一个项目上实时协作，视频产出效率提升了至少3倍。',
  },
  {
    name: '陈思琪',
    role: 'MCN机构内容总监',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20content%20director%20portrait%2C%20modern%20office%2C%20warm%20lighting%2C%20confident%20expression&width=100&height=100&seq=testimonial-02&orientation=squarish',
    content: '我们团队管理着30多个账号，每天要产出上百条视频。一起草视频的草稿管理系统和并行协作能力是我们的核心生产力工具。',
  },
  {
    name: '赵明哲',
    role: '品牌视频营销负责人',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20marketing%20manager%20portrait%2C%20modern%20workspace%2C%20warm%20lighting%2C%20clean%20background&width=100&height=100&seq=testimonial-03&orientation=squarish',
    content: '作为品牌方，我们需要频繁审核外包团队制作的视频。一起草视频的标注评论功能让反馈流程变得极其高效，沟通成本降低了60%以上。',
  },
];

export const stats = [
  { value: '500,000+', label: '注册创作者' },
  { value: '2,000万+', label: '协作视频项目' },
  { value: '98.5%', label: '服务满意度' },
  { value: '150+', label: '国家/地区覆盖' },
];

export const features = [
  {
    icon: 'ri-team-line',
    title: '多人实时协作',
    description: '支持最多50人同时在线编辑同一个视频项目，所有操作毫秒级实时同步，就像大家一起围在屏幕前工作。',
  },
  {
    icon: 'ri-git-branch-line',
    title: '智能草稿管理',
    description: '自动版本记录、可视化对比、分支管理——借鉴Git理念打造的草稿系统，让版本控制不再是噩梦。',
  },
  {
    icon: 'ri-cloud-line',
    title: '云端素材库',
    description: '集中存储、智能分类、快速检索，团队成员随时随地获取所需素材，告别文件传输的烦恼。',
  },
  {
    icon: 'ri-chat-check-line',
    title: '精准审阅反馈',
    description: '在时间轴的任意位置添加标注和评论，精确到帧级别的反馈定位，让沟通清晰高效。',
  },
  {
    icon: 'ri-rocket-2-line',
    title: '一键多平台发布',
    description: '打通B站、抖音、快手、YouTube等主流平台，一键完成多平台分发，从创作到发布零距离。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '企业级安全保障',
    description: 'AES-256加密传输与存储，SOC 2认证，细粒度权限控制，全方位守护你的创作资产。',
  },
];

export const workflowSteps = [
  {
    step: '01',
    icon: 'ri-user-add-line',
    title: '创建团队',
    description: '注册账号，创建你的创作团队空间，邀请成员加入',
  },
  {
    step: '02',
    icon: 'ri-upload-cloud-2-line',
    title: '上传素材',
    description: '将拍摄素材上传至云端素材库，智能分类自动整理',
  },
  {
    step: '03',
    icon: 'ri-edit-2-line',
    title: '协作编辑',
    description: '团队成员在一起草视频中实时协作编辑，标注反馈',
  },
  {
    step: '04',
    icon: 'ri-send-plane-line',
    title: '一键发布',
    description: '完成编辑后，一键导出或直接发布到各大视频平台',
  },
];